export function fetchApi(method, url, payload) {
  const headers = {
    'Content-Type': 'application/json',
  };

  const fetchOptions = {
    method,
    headers,
    credentials: 'same-origin',
  };

  if (payload) {
    fetchOptions.body = JSON.stringify(payload);
  }

  return fetch(url, fetchOptions).then(response => {
    if (!response.ok) {
      return response.text().then(responseText =>
        Promise.reject({
          status: response.status,
          data: parseTextResponse(responseText),
        })
      );
    }
    return response.text().then(parseTextResponse);
  });
}

function parseTextResponse(responseText) {
  try {
    // TODO look at response type header?
    return JSON.parse(responseText);
  } catch (e) {
    return responseText;
  }
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js